export default __webpack_public_path__ + "locales/sl/PortalUnavailable.json?hash=dc25d243910f0753b79aae2068f12dfb";